import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { AppAction, RootReducerState } from 'src/redux';
import { InventoryLayout } from 'src/layouts';
import { DefaultOwnerAddress, NFTType } from 'src/globals/constants';
import { Filter } from 'src/features/filter/components';
import { MyNFTList } from 'src/features/nftList';
import useCurrentAccount from 'src/hooks/useWalletAddress';
import InventoryHeader from './InventoryHeader';

const MySlimes = () => {
  const dispatch = useDispatch();

  const metaMaskWalletAddress = useCurrentAccount();

  const filterConfigs = useSelector((state: RootReducerState) => state.app.filterConfigs);
  const renderFilterContent = () => (
    <Filter
      filterBase={filterConfigs.slime}
      onBack={() => dispatch(AppAction.toggleInventoryFilter(false))}
    />
  );

  const nftType = NFTType.SLIME;

  return (
    <InventoryLayout renderFilterContent={renderFilterContent}>
      <Flex
        flex={{ base: 1 }}
        p={{ base: 2, md: 4 }}
        flexDirection={'column'}
        overflowY={'auto'}
        height={'inherit'}
      >
        <InventoryHeader nftType={nftType} />
        <MyNFTList ownerId={metaMaskWalletAddress || DefaultOwnerAddress} nftType={nftType} />
      </Flex>
    </InventoryLayout>
  );
};

export default MySlimes;
